// OP-3619 — O vocabulário do módulo, num lugar só.
//
// Os termos existiam dentro da Posição, como `title` do HTML: invisível em
// toque, lento no mouse e preso àquela tela — enquanto "Equip. fora" nos
// Contratos e "Em campo" na ficha da peça repetiam os mesmos conceitos sem
// explicação. Foi o D5 do dossiê, e o que quase fez a QA reportar um defeito
// que não existia.

export interface Termo {
  rotulo: string
  texto: string
}

const TERMOS = {
  fisico: {
    rotulo: 'Físico',
    texto: 'O que está fisicamente no local, sem tirar nada.',
  },
  disponivel: {
    rotulo: 'Disponível',
    texto: 'Peça: em estoque, íntegra e ativa. Consumível: físico menos o reservado.',
  },
  livre: {
    rotulo: 'Livre',
    texto: 'Físico menos o reservado. É o que uma nova separação ou transferência pode pegar.',
  },
  reservado: {
    rotulo: 'Reservado',
    texto: 'Já tem dono e ainda está aqui: separado para um pedido ou em transferência aprovada.',
  },
  comprometido: {
    rotulo: 'Comprometido',
    texto: 'Pedido aprovado que ainda falta separar. Ainda não segura saldo, mas vai segurar.',
  },
  foraDaBase: {
    rotulo: 'Fora da base',
    texto: 'Peças desta base que estão em campo ou em trânsito. Extraviadas não contam.',
  },
  equipFora: {
    rotulo: 'Equipamento fora',
    texto: 'Peças que saíram por este contrato e ainda não voltaram.',
  },
  emCampo: {
    rotulo: 'Em campo',
    texto: 'A peça está com o detentor, sob um contrato. Volta pela coleta da remessa.',
  },
  extraviado: {
    rotulo: 'Extraviado',
    texto: 'Declarada perdida numa conferência ou inventário. Continua no patrimônio até a baixa.',
  },
  critico: {
    rotulo: 'Crítico',
    texto: 'O disponível está abaixo do mínimo cadastrado para o item nesta praça.',
  },
}

/**
 * A união das chaves, não `string`: uma chave errada em `<AjudaGlossario>`
 * sumiria com o termo em silêncio, que é o defeito que o D5 já tinha.
 */
export type ChaveTermo = keyof typeof TERMOS

export const GLOSSARIO: Record<ChaveTermo, Termo> = TERMOS
